<div class="-article-skeleton">
  <div class="-article-skeleton-content">
    <div class="-left-pane">
      <div class="-article-header">
        <wp-skeleton height="40px" [width]="'58%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'86%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'72%'" [loading]="true"></wp-skeleton>
      </div>

      <wp-skeleton class="-article-image" [loading]="true"></wp-skeleton>

      @for (section of [1, 2, 3]; track section) {
      <div class="-article-lines">
        <wp-skeleton height="16px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="16px" [width]="'96%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="16px" [width]="'92%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="16px" [width]="section === 3 ? '64%' : '86%'" [loading]="true"></wp-skeleton>
      </div>
      }
    </div>

    <div class="-right-pane">
      <div class="sticky-right-pane">
        <wp-skeleton height="20px" [width]="'132px'" [loading]="true"></wp-skeleton>
        @for (item of [1, 2, 3, 4]; track item) {
        <wp-skeleton height="16px" [width]="item === 4 ? '70%' : '100%'" [loading]="true"></wp-skeleton>
        }
      </div>
    </div>
  </div>
</div>
